import httpClient from "./httpClient";

export const getUsers = (page,pagesSize) => httpClient.get(`/Users/FestivalUsers?festivalName=nimeh-shaban&page=${page}&pageSize=${pagesSize}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

export const putUsers = (params,id) => httpClient.put(`/Users/${id}`,params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
export const createLantaryCode = (params) => httpClient.post(`/Users/UserConfirm`,params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
export const setInvalidInfo = (params) => httpClient.post('/Users/InvalidInf',params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

export  const deleteUser = (id) => httpClient.delete(`/Users/${id}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })

